<div class="l-container  u-margin-top-xl">
  <div class="c-card">
    <div class="c-card__body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
